import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { axiosClient } from '@/lib/axios';

import type { ShareSaleDetails } from '../types';

type SharesParams = {
  companyID?: number;
  saleShareID: number;
};

type SharesResponse = {
  data: ShareSaleDetails;
};

export const getHighestInterestOffer = async ({ companyID, saleShareID }: SharesParams): Promise<ShareSaleDetails> => {
  const { data } = await axiosClient.get<SharesResponse>(
    `companies/${companyID}/cap-table/equities/issued-shares/for-sale/interested/${saleShareID}/highest-interest`,
  );
  return data.data;
};

type UseGetHighestInterestOffer = {
  companyID?: number;
  saleShareID: number;
  config?: Partial<UseQueryOptions<ShareSaleDetails>>;
};

export const useGetHighestInterestOffer = ({ companyID, saleShareID, config }: UseGetHighestInterestOffer) => {
  return useQuery({
    queryKey: ['highest-interest-offer', companyID, saleShareID],
    queryFn: () => getHighestInterestOffer({ companyID, saleShareID }),
    ...config,
    enabled: !!companyID && !!saleShareID,
  });
};
